import type { TOC } from '@ember/component/template-only';

import type { ComponentLike } from '@glint/template';

import MainComponent, {
	type ValidationErrorsType,
} from 'webapp/components/notifications/edit/form/anomaly/main';
import NotificationsEditFormBaseComponent, {
	type ChunkInterface,
	type MainChunkInterface,
} from 'webapp/components/notifications/edit/form/base';

import type { MetricAnomaly } from 'webapp/models-custom';

const TitleComponent: TOC<ChunkInterface> = <template></template>;

export default class NotificationsEditFormAnomalyComponent extends NotificationsEditFormBaseComponent {
	get model() {
		return this.args.model as MetricAnomaly;
	}

	get errors() {
		return this.args.errors as ValidationErrorsType;
	}

	get titleComponent() {
		return TitleComponent as ComponentLike<ChunkInterface>;
	}

	get mainComponent() {
		return MainComponent as ComponentLike<MainChunkInterface>;
	}
}
